module.exports = __webpack_public_path__ + "media/images/brand/logo-primary-132eb2367e51387caefbc6a85e9c8329.svg";